module.exports = __webpack_public_path__ + "static/media/cintia.e1b1678a.jpeg";